import styled from "styled-components";
import React from "react";
import {subduedTextColour} from "../../../style/styleConsts";

const Container = styled.div`
    align-self: flex-end;
    padding-right: 16px;
    color: ${props => props.color};
`;

const CommentLimitStatus = ({commentary, textLimit, commentaryRequired}) => {
    const commentLength = commentary ? commentary.length : 0;
    const limitText = `${commentLength}/${textLimit}`;
    let color = subduedTextColour;
    if (commentLength >= textLimit) {
        color = "red";
    }
    if (commentaryRequired && commentLength === 0) {
        color = "red";
    }
    return (<Container color={color} className="t-limit-status">{limitText}</Container>);
};

export default CommentLimitStatus;